import { GeneralCapability } from "api/types";

export interface DisplayGeneralCapability {
	name: GeneralCapability;
	id: string;
	grade?: number;
}

export const capabilities: DisplayGeneralCapability[] = [
	{
		name: "Literacy",
		id: "d63f054f-c10e-4a59-8955-e8c1711c7f5a",
	},
	{
		name: "Numeracy",
		id: "a0a20eed-9837-4c53-8f67-366d686447b7",
	},
	{
		name: "Information and Communication Technology (ICT) ",
		id: "8959ee96-911f-486b-94f4-38304e566bbc",
	},
	{
		name: "Critical and Creative Thinking",
		id: "d6d412f1-7433-4d4b-b5ab-0c65fc9565f1",
	},
	{
		name: "Personal and Social Capability",
		id: "aa8d0136-03a2-46bb-9de8-bda0538f946e",
	},
	{
		name: "Ethical Understanding",
		id: "0589e19b-78af-4aee-ae25-a08015c9d3d5",
	},
	{
		name: "Intercultural Understanding",
		id: "9acb712c-f9cf-4a5b-889e-46fe2fe7c27f",
	},
];

// Convert realms to an object for fast lookup
export type GeneralCapabilityMap = {
	[key in GeneralCapability]: DisplayGeneralCapability;
};

export const capabilityMap = capabilities.reduce((acc, capability) => {
	acc[capability.name] = capability;
	return acc;
}, {} as GeneralCapabilityMap);
